export default {
  info: {
    loading: false,
  },
  loading: false,
  on: true,
}
